import script from "./AffiliationTable.vue?vue&type=script&setup=true&lang=js"
export * from "./AffiliationTable.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__